export const APP_TOKEN_LIST_REQUEST = "APP_TOKEN_LIST_REQUEST";
export const APP_TOKEN_LIST_SUCCESS = "APP_TOKEN_LIST_SUCCESS";
export const APP_TOKEN_LIST_FAIL = "APP_TOKEN_LIST_FAIL";

export const APP_TOKEN_CREATE_REQUEST = "APP_TOKEN_CREATE_REQUEST";
export const APP_TOKEN_CREATE_SUCCESS = "APP_TOKEN_CREATE_SUCCESS";
export const APP_TOKEN_CREATE_FAIL = "APP_TOKEN_CREATE_FAIL";
export const APP_TOKEN_CREATE_RESET = "APP_TOKEN_CREATE_RESET";

export const APP_TOKEN_REVOKE_REQUEST = "APP_TOKEN_REVOKE_REQUEST";
export const APP_TOKEN_REVOKE_SUCCESS = "APP_TOKEN_REVOKE_SUCCESS";
export const APP_TOKEN_REVOKE_FAIL = "APP_TOKEN_REVOKE_FAIL";
export const APP_TOKEN_REVOKE_RESET = "APP_TOKEN_REVOKE_RESET";
